import {BrowserRouter, Route} from "react-router";
import {OverviewPage} from "@/pages/overview/over-view";
import Layout from "@/layout/layout";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
import { Provider } from 'react-redux'
import {store} from "@/store";
import {Extensions} from "@/pages/extensions";
import {Genaral} from "@/pages/plan-not-access/genaral.tsx";
import {SentryRoutes} from "@/instrument.ts";
import {CustomerFilePage} from "@/pages/system-account";
import {SystemPaymentMethod} from "@/pages/system-payment-method";
import FeatureRequestPage from "@/pages/feature-request";
import {ServiceRequestPage} from "@/pages/service-request/ServiceRequestPage";
import {AgentServiceRequestPage} from "@/pages/agent-service-request/AgentServiceRequestPage";
import {TicketDashboardPage} from "@/pages/ticket-dashboard/TicketDashboardPage";
import {EventCreatePage} from "@/pages/ticket-event/EventCreatePage";
import {TicketOrderCreatePage} from "@/pages/ticket-order/TicketOrderCreatePage";
import {ActivitySettingsPage} from "@/pages/ticket-activity/ActivitySettingsPage";
import PersonalMessagePage from "@/pages/personal-message/PersonalMessagePage.tsx";
import TranscriptionPage from "@/pages/transcription/TranscriptionPage.tsx";
import AudioAnalyzerPage from "@/pages/audio-analyzer/AudioAnalyzerPage.tsx";
import TextToSpeechPage from "@/pages/text-to-speech/TextToSpeechPage.tsx";
import TextToSpeechDocsPage from "@/pages/text-to-speech/TextToSpeechDocsPage.tsx";
import CallQualityPage from "@/pages/call-quality/CallQualityPage.tsx";
import ApiDocsPage from "@/pages/api-docs/ApiDocsPage.tsx";
import {InboxManagementPage} from "@/pages/inbox-management/InboxManagementPage";
import {SClassTestEditPage} from "@/pages/sclass-test";
import {ChipUserAssignmentPage} from "@/pages/ticket-chip-assignment/ChipUserAssignmentPage";
import AnnouncementsAdminPage from "@/pages/announcements-admin/AnnouncementsAdminPage.tsx";
import DocumentationListPage from "@/pages/documentation/DocumentationListPage.tsx";
import DocumentationEditPage from "@/pages/documentation/DocumentationEditPage.tsx";
import AiChatPage from "@/pages/ai-chat/AiChatPage.tsx";
import PhoneBookImportPage from "@/pages/phone-book-import/PhoneBookImportPage.tsx";

function App() {

  return (
    <Provider store={store}>
        <BrowserRouter>
           <SentryRoutes>
               <Route errorElement={<YourCustomRootErrorBoundary />}>
                   <Route path="/login" element={<LoginPage />} />
                   <Route path="/register" element={<RegisterPage />} />
                   <Route path="/reset-password" element={<ResetPasswordPage />} />
                   <Route element={<Layout/>}>
                       <Route index element={<OverviewPage />}/>
                       <Route path="extensions/" element={<Extensions/>}/>
                       <Route path="system/account/" element={<CustomerFilePage/>} />
                       <Route path="system/payment-method/" element={<SystemPaymentMethod/>} />
                       <Route path="403/" element={<Genaral/>}/>
                       <Route path="feature-request/" element={<FeatureRequestPage/>}/>
                       <Route path="crm/servicecall/" element={<ServiceRequestPage/>}/>
                       <Route path="crm/servicecall-agent/" element={<AgentServiceRequestPage/>}/>
                       <Route path="ticket/dashboard/" element={<TicketDashboardPage/>}/>
                       <Route path="ticket/event/add/" element={<EventCreatePage/>}/>
                       <Route path="ticket/event/:eventId/edit/" element={<EventCreatePage/>}/>
                       <Route path="ticket/ticketorder/add/" element={<TicketOrderCreatePage/>}/>
                       <Route path="ticket/activity/:activityId/edit/" element={<ActivitySettingsPage/>}/>
                       <Route path="ticket/chip-assignment/" element={<ChipUserAssignmentPage/>}/>
                       <Route path="personal-msg/" element={<PersonalMessagePage/>}/>
                       <Route path="tools/transcription/" element={<TranscriptionPage/>}/>
                       <Route path="tools/audio-analyzer/" element={<AudioAnalyzerPage/>}/>
                       <Route path="tools/text-to-speech/" element={<TextToSpeechPage/>}/>
                       <Route path="tools/text-to-speech/docs/" element={<TextToSpeechDocsPage/>}/>
                       <Route path="tools/call-quality/" element={<CallQualityPage/>}/>
                       <Route path="tools/ai-chat/" element={<AiChatPage/>}/>
                       <Route path="api-docs/" element={<ApiDocsPage/>}/>
                       <Route path="admin/inbox/" element={<InboxManagementPage/>}/>
                       <Route path="admin/announcements/" element={<AnnouncementsAdminPage/>}/>
                       <Route path="admin/documentation/" element={<DocumentationListPage/>}/>
                       <Route path="admin/documentation/new/" element={<DocumentationEditPage/>}/>
                       <Route path="admin/documentation/:id/edit/" element={<DocumentationEditPage/>}/>
                       <Route path="admin/phone-book/import/" element={<PhoneBookImportPage/>}/>
                       <Route path="sclass-test/:id/edit/" element={<SClassTestEditPage/>}/>
                   </Route>
               </Route>
          </SentryRoutes>
        </BrowserRouter>
    </Provider>
  )
}

export default App


// error boundary
import { useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import {useEffect} from "react";
export function YourCustomRootErrorBoundary() {
    const error = useRouteError() as Error;
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);
    return (
        <div>
            <h1>אופס!</h1>
            <p>נראה שיש בעיה במערכת</p>
            <p>אנא נסה שוב מאוחר יותר</p>
        </div>
    );
}
